import React from "react";
import ElementItem from "./elementItem";
import './elementpanel.scss';
import rowIco from '../../utils/images/elementPanel/row.png'
import inputIco from '../../utils/images/elementPanel/input.png'
import txtAreaIco from '../../utils/images/elementPanel/textarea.png'
import btnIco from '../../utils/images/elementPanel/btn.png'
import headingIco from '../../utils/images/elementPanel/heading.png'
import dropdownIco from '../../utils/images/elementPanel/Dropdown.png'
import lblIco from '../../utils/images/elementPanel/label.png'
import radioIco from '../../utils/images/elementPanel/radio.png'
import checkIco from '../../utils/images/elementPanel/checkbox.png'
import imgIco from '../../utils/images/elementPanel/pic.png'
import tabIco from '../../utils/images/elementPanel/tab.png'
import navIco from '../../utils/images/elementPanel/nav.png'
import tblIco from '../../utils/images/elementPanel/table.png'
import collapseIco from '../../utils/images/elementPanel/collapse.png'
import vidIco from '../../utils/images/elementPanel/video.png'
import mapIco from '../../utils/images/elementPanel/map.png'
import fileIco from '../../utils/images/elementPanel/file.png'
import typographyIco from '../../utils/images/elementPanel/typo.png'
import carouselIco from '../../utils/images/elementPanel/carousel.png'

const ElementItemList = () => {
  const itemList = [
    {
      id: 1,
      name: "Row",
      thumbnail: "src",
      type: "row",
      category: "layout",
      icon: "panel-icons pb-2",
      url: rowIco,
    },
    {
      id: 2,
      name: "Input Field",
      thumbnail: "src",
      type: "input",
      category: "element",
      icon: "panel-icons pb-2",
      url: inputIco,
    },
    {
      id: 3,
      name: "Text Area",
      thumbnail: "src",
      type: "txtarea",
      category: "element",
      icon: "panel-icons pb-2",
      url: txtAreaIco,
    },
    {
      id: 4,
      name: "Dropdown",
      thumbnail: "src",
      type: "dropdown",
      category: "element",
      icon: "panel-icons pb-2",
      url: dropdownIco,
    },
    {
      id: 5,
      name: "Button",
      thumbnail: "src",
      type: "btn",
      category: "element",
      icon: "panel-icons pb-2",
      url: btnIco,
    },
    {
      id: 6,
      name: "Heading",
      thumbnail: "src",
      type: "heading",
      category: "element",
      icon: "panel-icons pb-2",
      url: headingIco,
    },
    {
      id: 7,
      name: "Label",
      thumbnail: "src",
      type: "lbl",
      category: "element",
      icon: "panel-icons pb-2",
      url: lblIco,
    },
    {
      id: 8,
      name: "Radio",
      thumbnail: "src",
      type: "rdioBtn",
      category: "element",
      icon: "panel-icons pb-2",
      url: radioIco,
    },
    {
      id: 9,
      name: "Checkbox",
      thumbnail: "src",
      type: "chkBox",
      category: "element",
      icon: "panel-icons pb-2",
      url: checkIco,
    },
    {
      id: 10,
      name: "Image",
      thumbnail: "src",
      type: "img",
      category: "element",
      icon: "panel-icons pb-2",
      url: imgIco,
    },
    {
      id: 11,
      name: "Tab",
      thumbnail: "src",
      type: "tab",
      category: "element",
      icon: "panel-icons pb-2",
      url: tabIco,
    },
    {
      id: 12,
      name: "Navigation",
      thumbnail: "src",
      type: "navbar",
      category: "element",
      icon: "panel-icons pb-2",
      url: navIco,
    },
    {
      id: 13,
      name: "Table",
      thumbnail: "src",
      type: "table",
      category: "element",
      icon: "panel-icons pb-2",
      url: tblIco,
    },
    // {
    //   id: 14,
    //   name: "Modal",
    //   thumbnail: "src",
    //   type: "modal",
    //   category: "element",
    //   icon: "panel-icons fa fa-window-restore",
    // },
    {
      id: 15,
      name: "Collapsibal",
      thumbnail: "src",
      type: "collaps",
      category: "element",
      icon: "panel-icons pb-2",
      url: collapseIco,
    },
    {
      id: 16,
      name: "Embedded",
      thumbnail: "src",
      type: "video",
      category: "element",
      icon: "panel-icons pb-2",
      url: vidIco,
    },
    {
      id: 17,
      name: "Maps",
      thumbnail: "src",
      type: "map",
      category: "element",
      icon: "panel-icons pb-2",
      url: mapIco,
    },
    {
      id: 18,
      name: "File Upload",
      thumbnail: "src",
      type: "file",
      category: "element",
      icon: "panel-icons pb-2",
      url: fileIco,
    },
    {
      id: 19,
      name: "Typography",
      thumbnail: "src",
      type: "typography",
      category: "element",
      icon: "panel-icons pb-2",
      url: typographyIco,
    },
    {
      id: 20,
      name: "Carousel",
      thumbnail: "src",
      type: "carousel",
      category: "element",
      icon: "panel-icons pb-2",
      url: carouselIco,
    },
  ];

  // render all draggable component element

  const itemListComponent = () => {
    return itemList.map((item) => {
      return <ElementItem {...item} />;
    });
  };

  return (
    <div className="row property-panal ">
      <ul className="col-sm-12 align-center mb-1">{itemListComponent()}</ul>
    </div>
  );
};

export default ElementItemList;
